"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var parse_1 = require("@syl-editor/core-utilities/dist/lib/libs/parse");
var toolbar_1 = require("../modules/toolbar");
var typeset_1 = require("../utils/typeset");
var PLUGIN_NAME = 'font_size';
var FontSize = /** @class */ (function (_super) {
    __extends(FontSize, _super);
    function FontSize(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = PLUGIN_NAME;
        _this.tagName = function () { return 'span'; };
        _this.attrs = {
            size: {
                default: ''
            }
        };
        _this.parseDOM = [
            {
                style: 'font-size',
                defaultFontSize: 16,
                allowedValues: [],
                formatAttrs: function (v) { return v; },
                getAttrs: function (_style) {
                    var size = _style;
                    if (size === 'medium') {
                        return false;
                    }
                    else if (size === 'small' && this.allowedValues.length) {
                        size = this.allowedValues[0];
                    }
                    else if (size === 'large' && this.allowedValues.length) {
                        size = this.allowedValues[this.allowedValues.length - 1];
                    }
                    else if (!Number.isNaN(parse_1.getPx(size, this.defaultFontSize))) {
                        size = parse_1.getPx(size, this.defaultFontSize);
                    }
                    if (!size)
                        return false;
                    return this.formatAttrs({
                        size: size
                    });
                }
            }
        ];
        _this.toDOM = function (node) {
            var size = node.attrs.size;
            var attrs = {};
            if (size) {
                if (Number.isNaN(parseInt(size, 10))) {
                    attrs.style = "font-size: " + size + ";";
                }
                else if (_this.props.unit === 'px') {
                    attrs.style = "font-size: " + size + "px;";
                }
                else {
                    attrs.style = "font-size: " + (size / _this.parseDOM[0].defaultFontSize).toFixed(3).replace(/\.?0+$/, '') + "em;";
                }
            }
            return ['span', attrs, 0];
        };
        _this.props = props;
        _this.constructParseDOM(props);
        return _this;
    }
    FontSize.prototype.constructParseDOM = function (config) {
        if (!config)
            return;
        if (!config.allowedValues)
            return;
        var _a = typeset_1.getFormatAttrsByValue(config.allowedValues, 'size'), formatAttrs = _a.formatAttrs, values = _a.values, defaultValue = _a.defaultValue;
        if (defaultValue !== undefined) {
            this.parseDOM[0].defaultFontSize = +defaultValue;
        }
        this.parseDOM[0].allowedValues = values || [];
        this.parseDOM[0].formatAttrs = formatAttrs;
    };
    return FontSize;
}(core_utilities_1.Inline));
exports.FontSize = FontSize;
var FontSizeController = /** @class */ (function (_super) {
    __extends(FontSizeController, _super);
    function FontSizeController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.name = PLUGIN_NAME;
        _this.fontSize = 16;
        _this.constructValue = function (props) {
            if (props.values) {
                _this.toolbar.value = typeset_1.formatMenuValues('size', props.values);
            }
        };
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            type: toolbar_1.TOOL_TYPE.SELECT,
            icon: function (editor, attrs) {
                if (attrs.size)
                    return attrs.size;
                else
                    return _this.fontSize;
            },
            value: [
                {
                    text: '12',
                    attrs: {
                        size: 12
                    }
                },
                {
                    text: '16',
                    attrs: false
                },
                {
                    text: '20',
                    attrs: {
                        size: 20
                    }
                }
            ]
        };
        _this.constructValue(props);
        props.allowedValues &&
            props.allowedValues.some(function (val) {
                if (typeof val === 'object' && val.default) {
                    _this.fontSize = val.value;
                    return true;
                }
                return false;
            });
        return _this;
    }
    return FontSizeController;
}(core_utilities_1.SylController));
exports.FontSizeController = FontSizeController;
var FontSizePlugin = /** @class */ (function (_super) {
    __extends(FontSizePlugin, _super);
    function FontSizePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = PLUGIN_NAME;
        _this.Controller = FontSizeController;
        _this.Schema = FontSize;
        return _this;
    }
    return FontSizePlugin;
}(core_utilities_1.SylPlugin));
exports.FontSizePlugin = FontSizePlugin;
//# sourceMappingURL=font-size.js.map